export function logError(message: string, err?: any) {
    console.log(`Error: ${message}: %o`, err);
}
